import StandardEmailInput from './StandardEmailInput';
export default StandardEmailInput;